import { useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import { useTranslation } from 'react-i18next';

import { useFnol } from '../../context';

import { SecondaryButton } from '../../components';
import { STEP_SELECT_FNOL_TEMPLATE } from '../../CONSTANTS';
import ButtonWrapper from '../../components/ButtonWrapper';

const ContactPartnerView = ({ button }) => {
  const {
    fnolIntroMarkdown,
    clearFnolMarkdown,
    setSelectedFnolTemplate,
    setStep,
  } = useFnol();

  const { t } = useTranslation();

  useEffect(() => {
    window.parent.postMessage(
      {
        type: 'navigate',
      },
      '*'
    );
  }, []);

  useEffect(() => {
    return () => clearFnolMarkdown();
  }, []);

  const handleGoBackClick = () => {
    setSelectedFnolTemplate(null);
    setStep(STEP_SELECT_FNOL_TEMPLATE);
  };

  return (
    <>
      {fnolIntroMarkdown && (
        <ReactMarkdown linkTarget='_blank' children={fnolIntroMarkdown} />
      )}
      <ButtonWrapper>
        <SecondaryButton onClick={handleGoBackClick}>
          {t('buttons.back')}
        </SecondaryButton>
      </ButtonWrapper>
    </>
  );
};

export default ContactPartnerView;
